// test305
(305 && 0);
